import http from "@/request"


/**
 * 单位部门树
 * @param {*} data 
 * @returns 
 */
export function treeUnitDept(data) {
    return http({
        url: "/baseUnit/treeDepts",
        method: "post",
        data: data
    });
}

/**
 * 列表
 * @param {*} data 
 * @returns 
 */
export function listUnitDept(data) {
    return http({
        url: "/baseUnit/listDepts",
        method: "post",
        data: data
    });
}


/**
 * 保存单位部门
 * @param {*} data 
 * @returns 
 */
export function saveUnitDept(data) {
    return http({
        url: "/baseUnit/saveUnitDept",
        method: "post",
        data: data
    });
}

/**
 * 删除部门
 * @param {*} data 
 * @returns 
 */
export function deleteUnitDept(data) {
    return http({
        url: "/baseUnit/deleteUnitDept",
        method: "post",
        data: data
    });
}

/**
 * 获取模块名
 * @param {*} data 
 * @returns 
 */
export function resModuleList(data) {
    return http({
        url: "/baseResource/resModuleList",
        method: "post",
        data: data
    });
}
/**
 * 获取模块名
 * @param {*} data 
 * @returns 
 */
export function baseResourceList(data) {
    return http({
        url: "/baseResource/list",
        method: "post",
        data: data
    });
}
/**
 * 列表
 * @param {*} data 
 * @returns 
 */
export function saveInfo(data) {
    return http({
        url: "/baseResource/saveInfo",
        method: "post",
        data: data
    });
}
/**
 * 列表
 * @param {*} data 
 * @returns 
 */
export function getBaseResourceLastVersion(data) {
    return http({
        url: "/baseResource/getBaseResourceLastVersion",
        method: "post",
        data: data
    });
}
/**
 * 列表
 * @param {*} data 
 * @returns 
 */
export function updateStatus(data) {
    return http({
        url: "/baseResource/updateStatus",
        method: "post",
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/api/dept.js